import React from "react"
import logo from "../assets/svg/logo-small.svg";
import { Link } from 'gatsby-plugin-intl'

export default () => (
    <div onClick={() => window.fullpage_api.silentMoveTo("fp-home")} className="logo"><img src={logo} alt="" /></div>
);